var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnNewAlarm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 43",
    transform: "translate(-654.248 -741.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.751 21.75A3.754 3.754 0 0 1 6 18H.705A.7.7 0 0 1 0 17.25V15a.681.681 0 0 1 .225-.525l2.027-2.025V9A7.622 7.622 0 0 1 9 1.5V0h1.5v1.5a7.28 7.28 0 0 1 2.25.6v1.718a5.916 5.916 0 0 0-3-.818 6.007 6.007 0 0 0-6 6v3.749a.681.681 0 0 1-.225.525L1.5 15.3v1.2H18v-1.2l-2.025-2.025a.684.684 0 0 1-.224-.525V10.5h1.5v1.95l2.025 2.025A.681.681 0 0 1 19.5 15v2.25a.7.7 0 0 1-.7.751h-5.3a3.755 3.755 0 0 1-3.749 3.749zM7.5 18a2.25 2.25 0 1 0 4.5 0z",
    transform: "translate(666.248 752.75)",
    style: {
      fill: "#505866"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(680.5 755)",
    style: {
      fill: "#c13537"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 202",
    style: {
      fill: "none"
    },
    d: "M0 0h44v44H0z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNewAlarm);
export default __webpack_public_path__ + "static/media/icn_new_alarm.30d8efd794652dcdbf559807231f92b7.svg";
export { ForwardRef as ReactComponent };